import React from 'react';
import { PiCheckLight, PiXLight, PiWarningLight } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import Button from '../../shared/TailwindComponents/Button';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onSave: () => void;
  onDiscard: () => void;
  isLoading?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onSave,
  onDiscard,
  isLoading = false
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-ink/20 backdrop-blur-[2px]" />

      {/* Modal - a glass panel, and its buttons are the shared Button so a
          "save" here looks like a "save" anywhere else in the app. */}
      <div className="relative glass rounded-lg shadow-sm p-6 max-w-md mx-4 animate-in fade-in zoom-in-95">
        {/* Icon and Title */}
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 bg-warning-50 dark:bg-warning-500/10 rounded-full flex items-center justify-center">
            <PiWarningLight className="w-6 h-6 text-warning-600 dark:text-warning-400" />
          </div>
          <h2 className="text-lg font-semibold text-fg-strong">
            {t('Unsaved Changes')}
          </h2>
        </div>

        {/* Message */}
        <p className="text-sm text-fg-body mb-6">
          {t('You have unsaved changes in this spreadsheet. Would you like to save them before leaving?')}
        </p>

        {/* Buttons */}
        <div className="flex gap-3">
          <Button
            variant="neutral"
            onClick={onDiscard}
            disabled={isLoading}
            icon={<PiXLight className="w-4 h-4" />}
            className="flex-1 justify-center"
          >
            {t('Discard Changes')}
          </Button>
          <Button
            variant="primary"
            onClick={onSave}
            disabled={isLoading}
            isLoading={isLoading}
            icon={<PiCheckLight className="w-4 h-4" />}
            className="flex-1 justify-center"
          >
            {t('Save Changes')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
